import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Form, Modal, Button } from 'semantic-ui-react'
import firebase from 'firebase/app'

import RestaurantActions from '../../../reducers/restaurantReducer'

import FeeRateField from '../fields/dynamicFeeRate'
import FeeAmountField from '../fields/dynamicFeeAmount'
import FeeStatusField from '../fields/dynamicFeeStatusField'

class ModalDynamicFeeLink extends React.PureComponent {
  btnSubmitRef = React.createRef()

  dropdownRef = React.createRef()

  state = {
    selectedFee: '',
    feeRate: 0,
    feeAmount: 0,
    active: false,
    loading: false,
    removing: false,
  }

  componentDidMount() {
    const { feeData, action } = this.props

    if (action === 'edit') {
      this.setState({
        feeAmount: feeData.fee_amount || 0,
        feeRate: feeData.fee_rate || 0,
        active: feeData.active,
      })
    }
  }

  serializeFees = () => {
    const { branch, dynamicFees } = this.props

    const options = []
    _.map(dynamicFees || {}, (fee, feeKey) => {
      const branchFees = branch.dynamic_fees || {}
      const isExisted = branchFees[feeKey]

      if (!isExisted && !fee.archived) {
        options.push({
          key: feeKey,
          value: feeKey,
          text: `${fee.name} (${fee.type}), (${fee.go_to})`,
        })
      }
    })

    return options
  }

  onSubmit = e => {
    const { action } = this.props
    e.preventDefault()

    if (action === 'edit') {
      return this.saveDynamicFee()
    }

    const { selectedFee, active, feeAmount, feeRate } = this.state
    const { dynamicFees, storeId, branch } = this.props
    const updates = {}

    if (!selectedFee) {
      return alert('Please select dynamic fee!')
    }

    const fee = dynamicFees[selectedFee]

    if (!fee) return alert('Something went wrong, please reload the page!')

    const { key, ...restFeeData } = fee
    const feeToUse = fee.type === 'FIXED' ? { fee_amount: Number(feeAmount) } : { fee_rate: Number(feeRate) }
    const feeData = {
      ...restFeeData,
      ...feeToUse,
      created_at: Date.now(),
      active,
    }

    updates[`restaurants/${storeId}/branches/${branch.key}/dynamic_fees/${selectedFee}`] = feeData

    return this.linkDynamicFee(updates, feeData)
  }

  saveDynamicFee = () => {
    const { active, feeAmount, feeRate } = this.state
    const { feeData, storeId, branch } = this.props
    const { key, ...restFee } = feeData
    const updates = {}

    if (feeData.type === 'FIXED') {
      updates[
        `restaurants/${storeId}/branches/${branch.key}/dynamic_fees/${feeData.key}/fee_amount`
      ] = Number(feeAmount)
    } else {
      updates[`restaurants/${storeId}/branches/${branch.key}/dynamic_fees/${feeData.key}/fee_rate`] = Number(
        feeRate
      )
    }

    updates[`restaurants/${storeId}/branches/${branch.key}/dynamic_fees/${feeData.key}/active`] = active

    const feeToUse =
      feeData.type === 'FIXED' ? { fee_amount: Number(feeAmount) } : { fee_rate: Number(feeRate) }

    const newFeeData = {
      ...restFee,
      ...feeToUse,
      active,
    }

    return this.linkDynamicFee(updates, newFeeData)
  }

  linkDynamicFee = async (updates, data) => {
    const { selectedFee } = this.state
    const { feeData, action, setBranchDynamicFee, onClose, storeId, branch } = this.props

    let feeKey = selectedFee

    if (action === 'edit') {
      feeKey = feeData.key
    }

    try {
      this.setState({ loading: true })
      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) throw err

      setBranchDynamicFee(storeId, branch.key, { key: feeKey, data })
      onClose()
    } catch (error) {
      this.setState({ loading: false })
      alert(error.message || error)
    }
  }

  onRemove = async () => {
    try {
      const { feeData, deleteBranchDynamicFee, onClose, storeId, branch } = this.props
      const updates = {}

      this.setState({ removing: true })

      updates[`restaurants/${storeId}/branches/${branch.key}/dynamic_fees/${feeData.key}`] = null

      await firebase
        .database()
        .ref()
        .update(updates)

      deleteBranchDynamicFee(storeId, branch.key, { key: feeData.key })
      onClose()
    } catch (error) {
      this.setState({ removing: false })
      alert(error.message || error)
    }
  }

  render() {
    const { visible, onClose, feeData, action, dynamicFees } = this.props
    const { loading, removing, active, selectedFee, feeAmount, feeRate } = this.state

    let fee = dynamicFees[selectedFee] || {}

    if (action === 'edit') {
      fee = feeData
    }

    const feeType = fee.type || ''
    const title = action === 'edit' ? `Edit ${fee.name || ''}` : 'Link Dynamic Fee'

    return (
      <Modal size="tiny" open={visible}>
        <Modal.Header>{title}</Modal.Header>
        <Modal.Content>
          <Form
            onSubmit={this.onSubmit}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={loading}
          >
            {action !== 'edit' ? (
              <Form.Group widths="equal">
                <Form.Dropdown
                  label="Fee"
                  placeholder="Select Dynamic Fee"
                  fluid
                  search
                  selection
                  required
                  value={selectedFee}
                  options={this.serializeFees()}
                  onChange={(e, { value }) => this.setState({ selectedFee: value })}
                  ref={ref => {
                    this.dropdownRef = ref
                  }}
                />
              </Form.Group>
            ) : null}
            {feeType ? (
              <Form.Group widths="equal">
                <FeeStatusField onChange={value => this.setState({ active: value })} value={active} />
              </Form.Group>
            ) : null}

            {feeType === 'FIXED' ? (
              <Form.Group widths="equal">
                <FeeAmountField onChange={value => this.setState({ feeAmount: value })} value={feeAmount} />
              </Form.Group>
            ) : null}

            {feeType === 'PERCENTAGE' ? (
              <Form.Group widths="equal">
                <FeeRateField onChange={value => this.setState({ feeRate: value })} value={feeRate} />
              </Form.Group>
            ) : null}

            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          {action === 'edit' ? (
            <Button onClick={this.onRemove} color="red" disabled={loading || removing} loading={removing}>
              Remove
            </Button>
          ) : null}
          <Button disabled={loading} onClick={onClose}>
            Close
          </Button>
          <Button
            icon="checkmark"
            labelPosition="right"
            content="Save"
            disabled={loading}
            loading={loading}
            onClick={() => this.btnSubmitRef.click()}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapDispatch = {
  setBranchDynamicFee: RestaurantActions.setBranchDynamicFee,
  deleteBranchDynamicFee: RestaurantActions.deleteBranchDynamicFee,
}

export default connect(
  null,
  mapDispatch
)(ModalDynamicFeeLink)



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/dynamicFeeForm.js